import React from 'react';
import { Card, Badge, Row, Col, Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaBed, FaBath, FaCar, FaRulerCombined } from 'react-icons/fa';

const PropertyCard = () => {
  // Array of property objects
  const properties = [
    {
      image: "/images/property-2.webp",
      tag: "Feature",
      size: "550",
      rooms: 6,
      bathrooms: 4,
      garage: 3,
      title: "Marvel de Villa",
      location: "450 E 1st Ave, New Jersey",
      price: "$2550",
      period: "M",
      status: "FOR SALE",
    },
    {
      image: "/images/property-3.webp",
      tag: "Popular",
      size: "600",
      rooms: 5,
      bathrooms: 3,
      garage: 2,
      title: "Ruposi Bangla Cottage",
      location: "215 L AH Rod, California",
      price: "$550",
      period: "M",
      status: "FOR RENT",
    },
    {
      image: "/images/property-13.webp",
      tag: "New",
      size: "700",
      rooms: 4,
      bathrooms: 2,
      garage: 1,
      title: "Friuli-Venezia Giulia",
      location: "568 E 1st Ave, Miami",
      price: "$1200",
      period: "M",
      status: "FOR RENT",
    },
  ];

  return (
    <Container className="my-4" id='property-card'>
      <h2 className="text-center mb-4">Newly Added Properties</h2>
      <Row>
        {properties.map((property, index) => (
          <Col key={index} lg={4} md={6} className="mb-4">
            <motion.div
            >
              <Card className="h-100 shadow border-0 p-2">
                <div className="position-relative overflow-hidden rounded-top">
                  <Card.Img variant="top" src={property.image} alt={property.title} />
                  <Badge
                    bg={"warning"}
                    className="position-absolute top-0 start-0 m-2"
                  >
                    {property.tag}
                  </Badge>
                  <div className="position-absolute bottom-0 start-0 end-0 overflow-hidden">
                    <Row className="text-muted w-100 px-3 py-2 bg-custom-card m-0">
                      <Col className='border-end border-1 border-primary p-0 text-center fs-6 fw-bold'>
                        <FaRulerCombined className="me-1" /> {property.size}
                      </Col>
                      <Col className='border-end border-1 p-0 border-primary text-center fs-6 fw-bold'>
                        <FaBed className="me-1" /> {property.rooms}
                      </Col>
                      <Col className='border-end border-1 border-primary p-0 text-center fs-6 fw-bold'>
                        <FaBath className="me-1" /> {property.bathrooms}
                      </Col>
                      <Col className='fs-6 fw-bold'>
                        <FaCar className="me-1 p-0 text-center" /> {property.garage}
                      </Col>
                    </Row>
                  </div>
                </div>
                <Card.Body className='px-0'>

                  <Card.Title>{property.title}</Card.Title>
                  <Card.Text>{property.location}</Card.Text>
                  <h5>
                    {property.price} <small className="text-muted">/ {property.period}</small>
                  </h5>
                  <Badge bg="primary" className='p-2'>{property.status}</Badge>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PropertyCard;
